export default "__VITE_ASSET__0a4fe6ce__"